/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

import React from "react";

export default function PhotoGallery({ photoUrls = [], singlePhotoUrl = null }) {
  // Normalize URLs to be absolute or prefixed with /
  const normalizedPhotoUrls = Array.isArray(photoUrls)
    ? photoUrls.map((url) => (url.startsWith("http") ? url : `/${url}`))
    : [];

  const normalizedSingleUrl =
    singlePhotoUrl?.startsWith("http")
      ? singlePhotoUrl
      : singlePhotoUrl
      ? `/${singlePhotoUrl}`
      : null;

  if (normalizedPhotoUrls.length > 0) {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          marginTop: 8,
        }}
      >
        {normalizedPhotoUrls.map((url, idx) => (
          <a
            key={idx}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              flex: "0 0 100px",
              display: "block",
              textAlign: "center",
            }}
          >
            <img
              src={url}
              alt={`Photo ${idx + 1}`}
              style={{
                width: "100%",
                maxHeight: 200,
                objectFit: "contain",
                borderRadius: 8,
                cursor: "pointer",
                transition: "opacity 0.2s",
              }}
              onMouseOver={(e) => (e.currentTarget.style.opacity = 0.85)}
              onMouseOut={(e) => (e.currentTarget.style.opacity = 1)}
            />
          </a>
        ))}
      </div>
    );
  }

  if (normalizedSingleUrl) {
    return (
      <a href={normalizedSingleUrl} target="_blank" rel="noopener noreferrer">
        <img
          src={normalizedSingleUrl}
          alt="LPO submission photo"
          style={{
            width: "100%",
            maxHeight: 200,
            objectFit: "contain",
            borderRadius: 8,
            marginTop: 8,
            cursor: "pointer",
            transition: "opacity 0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.opacity = 0.85)}
          onMouseOut={(e) => (e.currentTarget.style.opacity = 1)}
        />
      </a>
    );
  }

  return null; // nothing to show
}
